// Resume Personal Data ***************************************************************************
// pathname: /v1/resume/personal-data
// ************************************************************************************************
import { ApiResumePersonalDataOk, useSwrApi } from '@hooks/useSwrApi';

interface SwrResumePersonalDataProps {
  locale?: Locale;
  shouldFetch?: boolean;
}

/**
 * @description SWR: fetch conversation details by id.
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 * @param shouldFetch - { boolean } - a flag indicating whether to start fetching conversation details. Default: true
 */

export const useSwrResumePersonalData = (props: SwrResumePersonalDataProps) => {
  // Destructure props
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiResumePersonalDataOk>({
    url: '/v1/resume/personal-data',
    shouldFetch,
    locale,
    apiOptions: {
      dedupingInterval: 60 * 1000, // 1 minute
      revalidateOnFocus: false,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
